export default class TaskState {

  static VALIDATED = 1;
  static PENDING_VALIDATION = 2;
  static PENDING = 3;
  static REFUSED = 4;

}


// WEBPACK FOOTER //
// ./src/app/shared/model/TaskState.js